module.exports = __webpack_public_path__ + "8384cf03a88f9a574579d09ed3e69752.pdf";